import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const vipTableBookingStripDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.vipStrip,
  componentType: LAYOUT_COMPONENT_TYPE.vipTableBookingStrip,
  registryBlockKey: REGISTRY_BLOCK.presentation.vipTableBookingStrip,
  displayOrder: 6,
  content: {
    heading: loc3('VIP-Tisch', 'VIP table', 'Bàn VIP'),
    supporting: loc3(
      'Erhöhte Lounge mit Flaschen-Service und eigenem Service.',
      'Raised lounge with bottle service and dedicated staff.',
      'Lounge cao với phục vụ chai và nhân viên riêng.',
    ),
    capacityNote: loc3('Bis 10 Gäste', 'Up to 10 guests', 'Tối đa 10 khách'),
    ctaLabel: loc3('VIP anfragen', 'Request VIP', 'Yêu cầu VIP'),
  },
  media: {},
};
